import {combine, forward, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {mapSortings, mapFilters} from 'utils/grid-mappers';

import {
    data$,
    fetchDataFx,
    filters$,
    filtersChanged,
    Gate,
    gridCacheReset,
    gridTokensCache$,
    pageNumber$,
    pageSize$,
    sortings$,
    sortingsChanged,
    tableStateCacheChanged,
    pageNumberChanged,
    fetchTotalCountFx,
} from './index';

data$.on(fetchDataFx.done, (state, {result}) => result).reset(Gate.close);
pageNumber$.reset(filtersChanged, sortingsChanged, Gate.close);
pageSize$.reset(Gate.close);
filters$.reset(Gate.close);
sortings$.reset(Gate.close);

gridTokensCache$
    .on(fetchDataFx.done, (state, {result}) => ({
        ...state,
        [pageNumber$.getState() + 1]: result.nextPageRef ?? null,
    }))
    .on(gridCacheReset, () => ({0: null}));

forward({
    from: tableStateCacheChanged,
    to: gridCacheReset,
});

sample({
    clock: merge([Gate.open, pageNumberChanged, sortingsChanged, filtersChanged]),
    source: combine({
        state: Gate.state,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        filters: filters$,
        sortings: sortings$,
        cache: gridTokensCache$,
    }),
    fn: ({state, pageNumber, pageSize, filters, sortings, cache}) => ({
        reportId: state.reportId,
        paging: {
            ...(cache[pageNumber]
                ? {
                      pageRef: cache[pageNumber] ?? null,
                  }
                : {
                      pageNumber,
                      pageSize,
                  }),
        },
        filters: mapFilters(filters),
        sortings: mapSortings(sortings),
    }),
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
fetchTotalCountFx.fail.watch(({error}) => showRestError(error as RestError));
